export function getStatusClassName(batchType) {
    switch (batchType) {
        case 'PENDING':
        case 'Pending':
        case '17':
          return 'pending';
        case 'Merchant':
        case 'merchant':
        case '9':
            return 'merchant';
        case 'closed':
        case 'Closed':
        case 'CLOSED':
        case 'Close':
        case 'close':
        case 'CLOSE':
        case '5':
            return 'closed';
        case 'Request':
        case 'request':
        case '19':
            return 'request';
        case 'square':
            return 'square';
        case 'reversed':
            return 'reversed';
        case 'Open':
        case 'OPEN':
        case 'open':
        case '4':
            return 'open';
        case 'Resolved':
        case 'Resolved-Merchant':
        case 'RESOLVED':
        case 'RESOLVED-MERCHANT':
        case 'CASE-RESOLVED':
            return 'Resolved';
        case 'Pended':
        case 'PENDED':
        case 'pended':
        case 'Pend':
        case 'pend':
        case 'PEND':
            return 'pend';
        case 'WAITING':
            return 'WAITING';   
        case 'New':
        case 'NEW':
            return 'NEW';
        case 'dispute':
        case 'Dispute':
            return 'Dispute';
        case 'inactive':
        case 'Inactive':
            return 'Inactive';
        case 'active':
        case 'Active':
            return 'Active';
        case 'TO-INVESTIGATOR':
        case 'to-investigator':
            return 'to-investigator';
        case 'info':
            return 'info';
        case 'hierarchy-selector':
            return 'hierarchy-selector';
        case 'success':
            return 'success';
         case 'warning':
              return 'warning';
        case 'Resolved':
        case 'Resolved-Bank':
        case 'RESOLVED':
        case 'RESOLVED-BANK':
            return 'Resolved-Bank';
    }
}